import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { FC } from "react";
import { View } from "react-native";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { EditIcon, TrashIcon } from "ui/gluestack/icon";

interface Props {
  role: RoleModel;
  onEdit?: (role: RoleModel) => void;
  onDelete?: (role: RoleModel) => void;
}

export const RoleActions: FC<Props> = ({ role, onEdit, onDelete }) => {
  return (
    <View className={"flex flex-row self-end gap-x-3 lg:gap-x-8"}>
      {onEdit ? (
        <Button
          size="xs"
          variant="link"
          onPress={() => onEdit(role)}
          className="px-2 lg:px-0"
        >
          <ButtonText className="hidden lg:block">Edit</ButtonText>

          <ButtonIcon as={EditIcon} />
        </Button>
      ) : null}
      {onDelete ? (
        <>
          <Button
            size="xs"
            action="negative"
            variant="outline"
            onPress={() => onDelete(role)}
          >
            <ButtonText className="hidden lg:block">Delete</ButtonText>
            <ButtonIcon as={TrashIcon} />
          </Button>
        </>
      ) : null}
    </View>
  );
};
